import { FieldName, SetFieldValue, SetValueConfig, UseFormMethods } from 'react-hook-form'

type FieldValues = Record<string, unknown>

type SetFieldValueTuple<TFieldValues extends FieldValues> = [
  FieldName<TFieldValues>,
  SetFieldValue<TFieldValues>,
]

/**
 * Helper function to set multiple values with react-hook-form using animation frames
 */
export const setValuesWith =
  <TFieldValues extends FieldValues>(setValue: UseFormMethods<TFieldValues>['setValue']) =>
  (values: Partial<TFieldValues>, config?: SetValueConfig, onComplete?: () => void): void => {
    const requestAnimationFrame =
      typeof window !== 'undefined'
        ? window.requestAnimationFrame
        : (callback: () => void) => {
            callback()
          }

    const setValueInternal = (valuesArray: Array<SetFieldValueTuple<TFieldValues>>): void => {
      const [valueToSet, ...remaining] = valuesArray
      setValue(valueToSet[0], valueToSet[1], config)

      if (!remaining.length) {
        onComplete?.()
        return
      }
      requestAnimationFrame(() => setValueInternal(remaining))
    }

    const valuesArray = Object.entries(values) as Array<SetFieldValueTuple<TFieldValues>>
    requestAnimationFrame(() => setValueInternal(valuesArray))
  }
